// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"4a986218","256":"25127aa5","799":"e864116b","973":"771331dc","998":"4e098765"}[chunkId] + ".chunk.css";
};